import { OnboardingStep, UnpersistedOnboardingStep } from '@ardoq/api-types';
import { fetchEntities, fetchJson, Method, toRequestOptions } from './api';
import { ApiResponse } from './types';

const createCompletedStep = ({
  key,
  completed,
}: UnpersistedOnboardingStep): ApiResponse<OnboardingStep> => {
  const request = new Request(
    `/api/onboarding-step`,
    toRequestOptions(Method.POST, { key, completed })
  );
  return fetchJson<OnboardingStep>(request);
};

const setStepCompleted = ({
  _id,
  key,
  completed,
}: OnboardingStep): ApiResponse<OnboardingStep> => {
  const request = new Request(
    `/api/onboarding-step/${_id}`,
    toRequestOptions(Method.PATCH, { key, completed })
  );
  return fetchJson<OnboardingStep>(request);
};

export const onboardingStepApi = {
  fetchAll: fetchEntities<OnboardingStep>('onboarding-step'),
  createCompletedStep,
  setStepCompleted,
};
